var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarsRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 66,
    viewBox: "0 0 54 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2777 42.8389L38.0398 42.2452L38.6951 36.5306L40.3699 41.9483L39.2777 42.8389ZM41.3893 45.0654L40.5155 43.9522L41.1709 42.6905L46.7777 43.3584L41.3893 45.0654ZM37.6029 45.4365L31.9961 44.7685L37.3116 43.0616L38.1854 44.1748L37.6029 45.4365ZM40.0786 51.5964L38.4039 46.1786L39.4961 45.2881L40.734 45.956L40.0786 51.5964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3635 47.6168L37.558 45.3915L38.1552 44.1712L37.2594 43.0944L35.6917 41.0845L38.0059 42.3048L39.2751 42.8791L40.3949 42.0177L42.4106 40.5103L41.2161 42.7355L40.5442 43.9558L41.44 45.0326L43.0824 46.9707L40.7682 45.8222L39.499 45.1762L38.3792 46.0376L36.3635 47.6168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25575 55.5244L3.68442 55.2555L3.98689 52.6678L4.75986 55.1211L4.25575 55.5244ZM5.23036 56.5326L4.82707 56.0285L5.12954 55.4572L7.71729 55.7596L5.23036 56.5326ZM3.48278 56.7006L0.89502 56.3982L3.34835 55.6252L3.75164 56.1293L3.48278 56.7006ZM4.62543 59.49L3.85246 57.0367L4.35657 56.6334L4.92789 56.9359L4.62543 59.49Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91084 57.7844L3.46213 56.7162L3.73778 56.1305L3.32431 55.6137L2.60073 54.6489L3.66887 55.2346L4.25462 55.5103L4.77146 55.0968L5.70177 54.3732L5.15047 55.4414L4.84037 56.0271L5.25384 56.544L6.01187 57.4743L4.94374 56.923L4.35799 56.6129L3.84115 57.0263L2.91084 57.7844Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3816 34.7793L43.5829 34.7355L44.2285 34.6882L44.4759 34.0743L44.9615 32.9704L44.9753 34.1886L45.0225 34.8342L45.6364 35.0816L46.7234 35.5372L45.5222 35.581L44.8596 35.5982L44.6122 36.2121L44.1736 37.3291L44.1298 36.1279L44.1125 35.4653L43.4986 35.2179L42.3816 34.7793Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8646 9.19396L13.7553 5.65467L9.90967 5.22129L13.6074 4.0656L14.0511 0.381851L15.1604 3.92114L19.006 4.35452L15.3083 5.51021L14.8646 9.19396Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7868 63.8738L49.7672 62.0862L48.4525 60.352L50.3428 61.4267L51.9813 60.219L51.0009 62.0065L52.3156 63.7407L50.4253 62.6661L48.7868 63.8738Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsRight);
export default __webpack_public_path__ + "static/media/stars_right.011cfe46144205a5b85abbeeed3ec187.svg";
export { ForwardRef as ReactComponent };